import { api } from "./api";

export interface PublicQuiz {
  quizId: string;
  title: string;
  description: string;
  instructions: string;
  startAt: string;
  endAt: string;
  timezoneId: string;
  durationMinutes: number;
  otpMode: "Email" | "Sms" | "Either" | "Both" | "None";
  idVerificationRequired: boolean;
  candidateCategories: string[];
  isOpen: boolean;
}

export interface RegistrationRequest {
  email: string;
  firstName: string;
  lastName: string;
  fatherName: string;
  mobile: string;
  category: string;
  dateOfBirth: string;   // YYYY-MM-DD
  channel: "email" | "sms" | "both";
}

export interface DispatchedOtp {
  channel: "Email" | "Sms";
  maskedRecipient: string;
}

export interface RegistrationResponse {
  candidateId: string;
  dispatched: DispatchedOtp[];
  /** Populated only when the quiz's OTP mode is None. */
  token?: string | null;
  expiresAt?: string | null;
}

export interface VerifyOtpRequest {
  channel?: "email" | "sms";
  code?: string;
  emailCode?: string;
  smsCode?: string;
}

export interface VerifyOtpResponse {
  token: string;
  expiresAt: string;
}

export interface CreateAttemptResponse {
  attemptId: string;
  state: string;
}

export interface UploadIdDocumentResponse {
  idDocumentId: string;
  verificationStatus: string;
}

export const quizApi = {
  getPublic: (quizId: string) =>
    api.get<PublicQuiz>(`/quizzes/${quizId}/public`).then((r) => r.data),

  register: (quizId: string, body: RegistrationRequest) =>
    api.post<RegistrationResponse>(`/quizzes/${quizId}/registrations`, body).then((r) => r.data),

  verifyOtp: (quizId: string, candidateId: string, body: VerifyOtpRequest) =>
    api.post<VerifyOtpResponse>(
      `/quizzes/${quizId}/registrations/${candidateId}/verify-otp`,
      body,
    ).then((r) => r.data),

  resendOtp: (quizId: string, candidateId: string, channel: "email" | "sms") =>
    api.post<DispatchedOtp>(
      `/quizzes/${quizId}/registrations/${candidateId}/resend-otp`,
      { channel },
    ).then((r) => r.data),

  createAttempt: (quizId: string) =>
    api.post<CreateAttemptResponse>(`/quizzes/${quizId}/attempts`).then((r) => r.data),

  uploadIdDocument: (
    attemptId: string,
    selfie: File,
    idDocument: File,
    idType: "Aadhaar" | "Passport" | "Pan" | "Other",
  ) => {
    const fd = new FormData();
    fd.append("selfie", selfie);
    fd.append("idDocument", idDocument);
    fd.append("idType", idType);
    return api.post<UploadIdDocumentResponse>(
      `/attempts/${attemptId}/id-documents`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } },
    ).then((r) => r.data);
  },
};
